import React from 'react';

import SqliteProvider from '~/data/db/SqliteProvider';
import OfflineSessionOrchestrator from '~/data/bootstrap/OfflineSessionOrchestrator';

/**
 * Cordova SQLite open + schema migration + post-auth data bootstrap.
 */
const AppDatabaseProvider: React.FC = ({ children }) => (
  <SqliteProvider>
    <OfflineSessionOrchestrator>{children}</OfflineSessionOrchestrator>
  </SqliteProvider>
);

export default AppDatabaseProvider;
